import { Avatar } from '@app/components/common/Avatar/Avatar';
import { FONT_SIZE } from '@app/styles/themes/constants';
import styled from 'styled-components';

export const Wrapper = styled.div`
  border: 1px solid #f0f0f0;
  max-height: calc(100vh - 200px);
  overflow: auto;
  border-radius: 7px;

  .ant-list-item {
    padding: 16px;
    cursor: pointer;
    &.active {
      background-color: var(--primary1-color);
      color: #fff;
    }

    .ant-list-item-meta {
      align-items: center;
    }

    // .ant-list-item-meta-description {
    //   color: var(--text-light-color);
    //   display: -webkit-box;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
    //   -webkit-line-clamp: 1;
    //   -webkit-box-orient: vertical;
    // }
  }
`;

export const AvatarWrapper = styled(Avatar)`
  color: #fff;
  background-color: var(--primary-color);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;

  button {
    svg {
      display: flex;
      align-items: center;
      font-size: 22px;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Status = styled.div`
  font-size: 12px;
  color: var(--text-light-color);
  margin-left: auto;
  text-transform: capitalize;
`;

export const Description = styled.div`
  font-size: ${FONT_SIZE.xs};
  color: var(--text-light-color);
  direction: rtl;
`;
